import React, { ReactElement } from 'react';
// import useStyles from './focusObject.jss';

function FocusObject(): ReactElement {
  // const classes = useStyles();
  return <div></div>;
}

export default FocusObject;
